import { createFileRoute } from "@tanstack/react-router"
import { SuccessStory1 } from "./-SuccessStory1"
import { SuccessStory2 } from "./-SuccessStory2"

export const Route = createFileRoute("/success-stories/")({
  component: RouteComponent,
})

function RouteComponent() {
  // return <SuccessStory1 />
  return <SuccessStory2 />
}
